/* eslint-disable no-param-reassign */
import { createSlice } from "@reduxjs/toolkit";
import {
  getCurrentSiteIdFromLocal,
  setCurrentSiteIdToLocal,
} from "services/site";

interface ISiteInfo {
  name: string;
}
interface ISiteSLiceState {
  currentSiteId: string;
  siteInfo: ISiteInfo;
}

const SiteSliceState: ISiteSLiceState = {
  currentSiteId: getCurrentSiteIdFromLocal(),
  siteInfo: {
    name: "",
  },
};

export const SiteSlice = createSlice({
  name: "Site",
  initialState: SiteSliceState,
  reducers: {
    setCurrentSiteId: (state, action) => {
      const siteId = action.payload;
      setCurrentSiteIdToLocal(siteId);
      state.currentSiteId = siteId;
    },
    setCurrentSiteInfo: (state, action) => {
      const siteInfo = action.payload;
      state.siteInfo = siteInfo;
    },
  },
});

export const { setCurrentSiteId, setCurrentSiteInfo } = SiteSlice.actions;

export default SiteSlice.reducer;
